import { Box, ListItem } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { ConnectedAccountCard_storeUser$key } from "./__generated__/ConnectedAccountCard_storeUser.graphql";
import { RoleTag } from "../UserAdmin/RoleTag";

export function ConnectedAccountCard(props: {
  storeUser: ConnectedAccountCard_storeUser$key;
  onPress: () => void;
}) {
  const storeUser = useFragment(
    graphql`
      fragment ConnectedAccountCard_storeUser on StoreUser {
        id
        role
        user {
          email
        }
      }
    `,
    props.storeUser
  );

  return (
    <ListItem
      isFree
      border="border-primary"
      right={
        <Box style={{ flexDirection: "row", alignItems: "center" }}>
          <Box spaceRight="small">
            <RoleTag role={storeUser.role} />
          </Box>
          <ListItem.NavArrow />
        </Box>
      }
      onPress={props.onPress}
    >
      <ListItem.Title>{storeUser.user.email}</ListItem.Title>
    </ListItem>
  );
}
